import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertiesComponent } from './catalogue-properties/properties.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MultiSelectorComponent } from './multi-selector/multi-selector.component';
import { CreateComponent } from './create/create.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { PropertySelectorComponent } from './property-selector/property-selector.component';
import { ValueSelectorComponent } from './value-selector/value-selector.component';
import { SelectorComponent } from './selector/selector.component';
import { SelectorItemComponent } from './selector-item/selector-item.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    PropertiesComponent,
    MultiSelectorComponent,
    PropertySelectorComponent,
    CreateComponent,
    ValueSelectorComponent,
    SelectorComponent,
    SelectorItemComponent
  ],
  imports: [
    CommonModule,
    MatChipsModule,
    MatOptionModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIconModule,
    FormsModule,
    MatButtonModule,
    MatProgressBarModule,
    MatInputModule
  ],
  exports: [
    PropertiesComponent,
    PropertySelectorComponent,
    SelectorComponent,
    SelectorItemComponent
  ]
})
export class PropertyModule {}
